import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const copyPasteStore = {
  namespaced: true,
  state: {
    taskMap: null,
    isOpenCopyPopup: false,
    hasCopiedTask: false,
    copiedTask: null,
    copySettingsConfig: null,
    copySettingsConfigsMap: { },
    isInsertingProcess: false,
    currentProjectId: null,
    copyPastError: null,
  },
  getters,
  mutations,
  actions,
};

export default copyPasteStore;
